import 'regenerator-runtime/runtime';

import 'unfetch/polyfill/index';
import 'custom-event-polyfill';
import 'url-polyfill';
import './utils/polyfills.js';

import * as Util from './utils/utils';
import * as FormUtil from './utils/formUtils';
import * as BrowserUtil from './utils/browser';
import * as DomUtil from './utils/domUtils';
import StorageManager from '../common/services/StorageService';
import PrivacyManager from '../common/services/PrivacyService';
import ConfigService from '../common/services/ConfigService';
import TrackingService from '../common/services/TrackingService';

import Lang from './utils/Lang';
import Analytics from './modules/Analytics';
import { buildAPI } from './modules/Api';
import App from './modules/App';
import AppFlow from './modules/AppFlow';
import Overlay from './modules/Overlay';
import Insights from './modules/Insights';
import User from './modules/User';
import Auth from './modules/Auth';
import EmbedListener from './modules/EmbedListener';
import UIFlow from './modules/UIFlow';

import Templates from './templates/templates';

// DO NOT REMOVE ANY OF THESE APPRENTLY UNUSED IMPORTS
// THEY ARE HERE SO THEY'RE ON THE GLOBAL SCOPE
// DISPLAY WILL BREAK IF YOU REMOVE THEM

import DisplayItem from './modules/DisplayItem';
import { debug, debugLevel, getDebugLevel } from './modules/Debug';
import Share from './modules/Share';
import * as Tooltips from './modules/Tooltips';

// Module specific
import Coupons from './modules/Coupons';
import Metrics from './modules/Metrics';
import Quiz from './modules/Quiz';
import QuizLeaderboard from './modules/QuizLeaderboard';
import QuizResults from './modules/QuizResults';
import EntryForm from './modules/EntryForm';
import { SocialMosaic, MosaicTip } from './modules/SocialMosaic';
import ContentClaim from './modules/ContentClaim';
import LoyaltyLeaderboard from './modules/LoyaltyLeaderboard';
import LoyaltyProfile from './modules/LoyaltyProfile';
import LoyaltyRewards from './modules/LoyaltyRewards';

import { isVersion, AnalyticsEvents, AllAnalyticsEvents } from '../common/config/api.js';

// The NGX object.
const NGX = {
  // Init.
  init: function() {
    var $ = require('jquery');
    var jQBridget = require('jquery-bridget');
    var Packery = require('packery');
    var imagesLoaded = require('imagesloaded');

    jQBridget('packery', Packery, $);

    imagesLoaded.makeJQueryPlugin($);

    Object.assign(window, {
      log: {
        debug:         debug,
        setDebugLevel: debugLevel,
        getDebugLevel: getDebugLevel,
      },
    });

    // Checks for ?debug=<level> in query string and enables debug mode
    // Do this super early, to catch any debug logging in init methods
    (function(level) {
      if (level) {
        debugLevel(parseInt(level, 10));
      }
    })(BrowserUtil.queryStringObject('debug'));

    // Initialises the main App
    App.init();

    // Initialises Analytics, depends on App so must be called after
    Analytics.init();

    // Initialises DisplayItem listeners
    DisplayItem.init();

    // Initialises the Quiz if a quiz campaign
    if (App.config.type === 'type.campaignobject.quiz') {
      Quiz.init();
    }

    // Initialises sharing
    Share.init();

    -require('expose-loader?exposes=$,jQuery!jquery');
    -require('expose-loader?exposes=_|_|true!underscore');
    -require('expose-loader?exposes=imagesLoaded!imagesloaded');

    // Initialises the Embed Listener for cross frame communication
    EmbedListener.init();

    if (App.config.claimContent === 'true') {
      ContentClaim.init();
    }

    // Alias a subset of the Event object methods to our top level namespace to make it
    // less verbose for clients to use (WYN-709).
    const eventAliases = { on: null, once: null, off: null, trigger: null };
    for (const eventAlias in eventAliases) {
      eventAliases[eventAlias] = function() {
        return App.Events[eventAlias].apply(App.Events, arguments);
      };
    }

    // Add a compatibility layer for our events so API users can subscribe to events with
    // MX and Legacy using the same API
    const compatibility = {
      api: buildAPI(this.app.App.Events, Analytics).bind(this),
    };

    Object.assign(window.NGX, eventAliases, compatibility);

    // WYN-6333 Init these NGXD services here so they are available in EntryForm.js init.
    ConfigService.init(App.config, window.NGX.context);
    StorageManager.init();
    PrivacyManager.init(ConfigService, StorageManager);

    // Integration init needs to follow privacy manager init so we know what consents we have for analytics.
    Analytics.initIntegrations();
    // Init the Tracking Service, to track the user interaction with the page
    TrackingService.init(StorageManager, App.config.shouldAddTrackingTokens);
  },

  // The app object.
  app: {
    Analytics: {
      init:    Analytics.init,
      trigger: Analytics.trigger,
    },
    App:            App,
    Auth:           Auth,
    Browser:        BrowserUtil,
    Dom:            DomUtil,
    Embed:          EmbedListener,
    Form:           FormUtil,
    Insights:       Insights,
    SocialMosaic:   SocialMosaic,
    StorageManager: StorageManager,
    ConfigService:  ConfigService,
    PrivacyManager: PrivacyManager,
    TrackingService: TrackingService,
    User:           User,
    Util:           Util,
    appFlow:        AppFlow,
    entryForm:      EntryForm,
    isVersion:      isVersion,
    lang:           Lang,
    overlay:        Overlay,
    quiz:           Quiz,
    templates:      Templates,
    uiFlow:         UIFlow,
  },

  Analytics,

  isVersion,
};

export default NGX;
